import React, { Component } from 'react';
import {Button, TextField} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
const styles = makeStyles({
  root: {
    padding: '15px'
  }
})
const Textinput = (props) => {
  const classes = styles();
    return (
      <div>
        <TextField className={classes.root} type="text" variant="outlined" color="primary" value={props.room_id} onChange={props.onChange_room} name="room_name" label="Room id" /><br />
        <TextField className={classes.root} type="text" variant="outlined" color="primary" value={props.username} onChange={props.onChange2} name="username" label="Username" /><br />
        <Button className={classes.root} variant="contained" color="primary" onClick={props.joinroom}>Manda</Button>
      </div>
    )
  }
class Roommessage extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <div>
                <Textinput onChange_room={this.props.onChange_room} joinroom={this.props.joinroom} onChange2={this.props.onChange2} username={this.props.username} room_id={this.props.room_id}/>
            </div>
        )
    }
}

export default Roommessage